function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getInvoiceRecordDetail } from '@/api/invoiceRecord';
import InvoiceUploadForm from './InvoiceUploadForm.vue';
export default {
  name: 'InvoiceRecordDetail',
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      invoiceId: null,
      dataDetail: {}
    };
  },
  components: {
    InvoiceUploadForm: InvoiceUploadForm
  },
  methods: {
    getDetail: function getDetail() {
      this.getInvoiceDetail(this.invoiceId);
    },
    /** 开票上传操作 */handleUploadInvoice: function handleUploadInvoice(id) {
      this.$refs.uploadFormRef.open(id);
    },
    /** 格式化时间 */formatDateTime: function formatDateTime(time) {
      if (!time) return '-';
      if (typeof time === 'number' && time > 1000000000000) {
        time = new Date(time);
      }
      if (time instanceof Date) {
        return time.toISOString().slice(0, 19).replace('T', ' ');
      }
      if (typeof time === 'string' && time.includes('-')) {
        return time.slice(0, 19);
      }
      return time || '-';
    },
    /** 订单状态文字 */orderStatusText: function orderStatusText(status) {
      var map = {
        0: '待支付',
        1: '待发货',
        2: '部分发货',
        3: '待核销',
        4: '待收货',
        5: '已收货',
        6: '已完成',
        9: '已取消'
      };
      return map[status] || '-';
    },
    /** 订单状态标签颜色 */orderStatusTag: function orderStatusTag(status) {
      var map = {
        0: 'danger',
        1: 'warning',
        4: 'primary',
        5: 'success',
        6: 'success',
        9: 'info'
      };
      return map[status] || '';
    },
    /** 支付方式文字 */payTypeText: function payTypeText(type) {
      var map = {
        weixin: '微信支付',
        alipay: '支付宝',
        yue: '余额支付'
      };
      return map[type] || type || '-';
    },
    /** 支付渠道文字 */payChannelText: function payChannelText(channel) {
      var map = {
        public: '公众号',
        mini: '小程序',
        h5: '网页支付',
        yue: '余额',
        wechatIos: '微信Ios',
        wechatAndroid: '微信Android',
        alipay: '支付宝',
        alipayApp: '支付宝App'
      };
      return map[channel] || channel || '-';
    },
    /** 退款状态文字 */refundStatusText: function refundStatusText(status) {
      var map = {
        0: '未退款',
        1: '申请中',
        2: '部分退款',
        3: '已退款'
      };
      return map[status] || '-';
    },
    /** 获取发票详情 */getInvoiceDetail: function () {
      var _getInvoiceDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return getInvoiceRecordDetail(id);
            case 1:
              res = _context.v;
              console.log(res);
              this.dataDetail = res;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('获取发票信息失败:', _t);
              this.$message.error('获取发票信息失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getInvoiceDetail(_x) {
        return _getInvoiceDetail.apply(this, arguments);
      }
      return getInvoiceDetail;
    }(),
    /** 打开弹窗 */open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.dialogVisible = true;
              this.loading = true;
              this.invoiceId = id;
              _context2.p = 1;
              _context2.n = 2;
              return this.getInvoiceDetail(id);
            case 2:
              _context2.p = 2;
              this.loading = false;
              return _context2.f(2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[1,, 2, 3]]);
      }));
      function open(_x2) {
        return _open.apply(this, arguments);
      }
      return open;
    }()
  }
};